export default __webpack_public_path__ + "img/op-home.8dd5f4ee.png";